import {useBrandResource} from "src/state/hooks/useAsyncResource";

function useBrand(brandSlug) {
  const {data: brand, meta} = useBrandResource({brandSlug});

  return [brand, meta];
}

export default useBrand;
